import { mergeClassName as e } from "../../utils/data.js";
import { Loader as t } from "../Loader/Loader.js";
import n from "./ImageGallery.module.js";
import { Typography as r } from "../Typography/Typography.js";
import { useEffect as i, useState as a } from "react";
import { Fragment as o, jsx as s, jsxs as c } from "react/jsx-runtime";
import { CaretLeftIcon as l, CaretRightIcon as u } from "@phosphor-icons/react";
//#region lib/components/ImageGallery/GalleryFrame.tsx
function d({ canPrev: t, canNext: r, onPrev: i, onNext: a, size: d = 20 }) {
	return /* @__PURE__ */ c(o, { children: [t && /* @__PURE__ */ s("button", {
		type: "button",
		className: e(n.arrow, n.arrowLeft),
		"aria-label": "Previous image",
		"data-testid": "gallery-prev",
		onClick: (e) => {
			e.stopPropagation(), i();
		},
		children: /* @__PURE__ */ s(l, { size: d })
	}), r && /* @__PURE__ */ s("button", {
		type: "button",
		className: e(n.arrow, n.arrowRight),
		"aria-label": "Next image",
		"data-testid": "gallery-next",
		onClick: (e) => {
			e.stopPropagation(), a();
		},
		children: /* @__PURE__ */ s(u, { size: d })
	})] });
}
function f({ image: o, objectFit: l, disableAnimation: u, footer: d, arrows: f, action: p, onActivate: m, fullscreen: h = !1, testId: g = "gallery-image" }) {
	let [_, v] = a(!0), [y, b] = a(!1);
	i(() => {
		v(!0), b(!1);
	}, [o.src]);
	let x = y && o.fallbackSrc ? o.fallbackSrc : o.src, S = !!m;
	return /* @__PURE__ */ c("div", {
		className: e(h ? n.frameFullscreen : n.frame, S ? n.clickable : void 0),
		role: S ? "button" : void 0,
		tabIndex: S ? 0 : void 0,
		onClick: m,
		onKeyDown: S ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), m?.());
		} : void 0,
		children: [
			/* @__PURE__ */ s("img", {
				src: x,
				alt: "",
				role: "img",
				"data-testid": g,
				className: u ? n.image : e(n.image, n.animate),
				style: { objectFit: l },
				onLoad: () => {
					v(!1);
				},
				onError: () => {
					!y && o.fallbackSrc ? b(!0) : v(!1);
				}
			}, x),
			_ && /* @__PURE__ */ s("div", {
				className: n.loader,
				children: /* @__PURE__ */ s(t, { size: "md" })
			}),
			!_ && o.labels?.map((e, t) => /* @__PURE__ */ s("span", {
				className: n.label,
				style: e.position,
				children: typeof e.content == "string" ? /* @__PURE__ */ s(r, {
					variant: "caption",
					weight: "medium",
					children: e.content
				}) : e.content
			}, e.key ?? t)),
			!_ && f,
			!_ && p,
			!_ && d && /* @__PURE__ */ s("div", {
				className: n.footer,
				children: d
			})
		]
	});
}
//#endregion
export { d as GalleryArrows, f as GalleryFrame };
